<div class="certificate-preview-modal">
  <div class="certificate-preview-modal__header">
    <button mat-icon-button class="button button--icon button--transparent" aria-label="Close" (click)="dialogRef.close()">
      <lib-icon icon="x"></lib-icon>
    </button>
  </div>
  <div class="certificate-preview-modal__body">
    <div class="certificate-preview-modal__body--title">
      {{certificate.title}}
    </div>
    @if (isLoading) {
      <mat-spinner diameter="40"></mat-spinner>
    }
    @if (image; as certificateImage) {
      <img class="certificate-preview-modal__body--image" [src]="certificateImage" [attr.alt]="certificate.title" (load)="onImageLoad()" (error)="onImageLoad()">
    }
  </div>
</div>
